import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import StatusBadgeCst from "@components/StatusBadgeCst";
import { InitiativeListItem } from "../types";

interface InitiativeRowProps {
  initiative: InitiativeListItem;
  selected: boolean;
  onToggle: (next: boolean) => void;
}

const InitiativeRow: React.FC<InitiativeRowProps> = ({ initiative }) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  const isActive = (initiative.status || "").toUpperCase() === "ACTIVE";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        minWidth: 0,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {initiative.name}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            color: theme.palette.text.primary,
            lineHeight: 1.4,
          }}
        >
          {`ID: ${initiative.id}`}
        </Typography>
      </Box>

      {isActive && (
        <StatusBadgeCst
          label={t("associate-initiative.status.active") || "Attivo"}
          variant="active"
        />
      )}
    </Box>
  );
};

export default InitiativeRow;
